import {Button} from "@heroui/react";
import {useAudioPlayer, useGlobalAudioPlayer} from 'react-use-audio-player';
import toast from 'react-hot-toast';
import _ from 'lodash';
import {useLocalStorage, useToggle} from '@mantine/hooks';
import {useState} from 'react';

export default function AudioPlayButton({children, trigger, src = undefined, onClicked, ...props}) {
	const [currentPlay, setCurrentPlay] = useLocalStorage({
		key: 'currentPlay',
		initialValue: null
	});
	const {load, playing, play, isReady, isLoading, stop, src: audioUrl} = useGlobalAudioPlayer();
	const playAudio = async (url = src) => {
		await setCurrentPlay(null);
		if (!url) {
			toast.error('No audio file found');
			return;
		}
		await setCurrentPlay(url)
		await load(url, {
			autoplay: true,
			onend: () => {
				setCurrentPlay(null);
			}
		});
	};
	
	return (
		<>
			<Button
				className="bg-white/20"
				{...props}
				key={src}
				aria-label={src || 'Audio Play Button'}
				aria-labelledby={src || 'Audio Play Button'}
				isLoading={currentPlay == src && isLoading}
				isDisabled={_.isEmpty(src)}
				preventFocusOnPress
				onPress={(e) => {
					audioUrl == src ? playing ? stop() : playAudio() : playAudio()
					if (typeof onClicked === 'function') onClicked()
			}} isIconOnly radius="full" color="">
				<i className={`hgi-stroke ${audioUrl == src && playing ? 'hgi-pause' : 'hgi-play'} text-xl`}></i>
			</Button>
		</>
	);
}
